<pbc-filter-preset
  [filter]="touren.preset$ | async"
  [filters]="touren.presets$ | async"
  [name]="touren.search$ | async"
  (select)="touren.setFilter($event)"
  (save)="touren.writeFilter($event)"
  (delete)="touren.deleteFilter($event)"
></pbc-filter-preset>
